var _circle, _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryNovaPoshtaDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 15.5,
    cy: 15.0002,
    r: 12.6316,
    fill: "#169CE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.661 10.3369V16.5264H13.5115V13.8737H10.3107V16.5264H9.16119V10.3369H10.3107V12.8923H13.5115V10.3369H14.661ZM21.8793 10.3369V16.5264H20.7475V11.3095H17.5378V16.5264H16.4061V10.3369H21.8793Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.86865,
    y: 2.36816,
    width: 25.2632,
    height: 25.2632,
    rx: 3.78947,
    fill: "#758295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6233 10.993C21.6835 10.974 21.7627 11.0119 21.8419 11.1161C21.8419 11.1161 21.8419 11.1161 25.4214 14.6071C25.6305 14.8155 25.6305 15.1311 25.4214 15.2858C25.4214 15.2858 25.4214 15.2858 21.8419 18.8305C21.7627 18.9347 21.6835 18.9599 21.6233 18.9284C21.5632 18.8968 21.5251 18.8053 21.5251 18.6727V11.2202C21.5251 11.0908 21.5632 11.0119 21.6233 10.993Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4997 5.17529H15.7531L15.997 5.2763C15.997 5.2763 15.997 5.2763 19.681 8.9252C19.8394 9.13353 19.7856 9.29135 19.5227 9.29135C19.5227 9.29135 19.5227 9.29135 17.9958 9.29135C17.7329 9.29135 17.5238 9.49968 17.5238 9.76167C17.5238 9.76167 17.5238 9.76167 17.5238 12.4699C17.5238 12.7319 17.3116 12.9402 16.9948 12.9402C16.9948 12.9402 16.9948 12.9402 14.3118 12.9402C14.0489 12.9402 13.8366 12.7319 13.8366 12.4699C13.8366 12.4699 13.8366 12.4699 13.8366 9.76167C13.8366 9.49968 13.6276 9.29135 13.3615 9.29135H11.7301C11.4672 9.29135 11.4133 9.13353 11.5717 8.9252C11.5717 8.9252 11.5717 8.9252 15.2589 5.2763L15.4997 5.17529Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72837 10.9141C9.79489 10.9456 9.83607 11.0372 9.83607 11.1698V18.7769C9.83607 18.9095 9.79489 18.9884 9.72837 19.0136C9.66502 19.0389 9.57315 19.0136 9.46545 18.9347C9.46545 18.9347 9.46545 18.9347 5.83209 15.2858C5.62303 15.1311 5.62303 14.8155 5.83209 14.6072C5.83209 14.6072 5.83209 14.6072 9.46545 11.0119C9.57315 10.9078 9.66502 10.8825 9.72837 10.9141Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.312 16.9019C14.312 16.9019 14.312 16.9019 16.9951 16.9019C17.3118 16.9019 17.5241 17.1102 17.5241 17.3722C17.5241 17.3722 17.5241 17.3722 17.5241 20.2383C17.5241 20.5508 17.7332 20.7591 17.9961 20.7591H19.4184C19.6813 20.7591 19.7858 20.9137 19.5768 21.0716C19.5768 21.0716 19.5768 21.0716 15.9973 24.6668C15.8895 24.771 15.7597 24.8246 15.6266 24.8246C15.4968 24.8246 15.3637 24.771 15.2592 24.6668C15.2592 24.6668 15.2592 24.6668 11.6797 21.0716C11.4674 20.9137 11.572 20.7591 11.8349 20.7591C11.8349 20.7591 11.8349 20.7591 13.3617 20.7591C13.6278 20.7591 13.8369 20.5508 13.8369 20.2383C13.8369 20.2383 13.8369 20.2383 13.8369 17.3722C13.8369 17.1102 14.0491 16.9019 14.312 16.9019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryNovaPoshtaDisabled);
export default __webpack_public_path__ + "static/media/delivery_nova_poshta_disabled.ad50a2e7e0471a964b385ee82c49b790.svg";
export { ForwardRef as ReactComponent };